/*
 * @Date: 2024-08-08 23:25:17
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-08-09 00:04:22
 */
import store from "../store";
import { getActivity } from "@/api/auth.js";
export default async () => {
  try {
    const { data } = await getActivity();
    store.commit("setActivityKey", data);
  } catch (error) {
    console.log("error", error);
  }
};
